<div id="maintenance" class="flex-column-center-center">
  <div class="content mb-24 mt-32 flex-column-center-center">
    <div class="error-code">{{ "ERROR_503.MAINTENANCE" | translate }}</div>

    <div class="humorous-title">
      {{ "ERROR_503.HUMOROUS_TITLE" | translate }}
    </div>

    <div class="sub-message">
      {{ "ERROR_503.SUB_MESSAGE" | translate }}
    </div>

    <div class="humorous-message">
      {{ "ERROR_503.HUMOROUS_MESSAGE" | translate }}
    </div>

    <div class="auto-check">
      <span *ngIf="!retrying">{{
        "ERROR_503.AUTO_CHECK" | translate: { seconds: countdown }
      }}</span>
      <span *ngIf="retrying">{{
        "ERROR_503.AUTO_CHECK_NOW" | translate
      }}</span>
    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="onRetry()"
      [disabled]="retrying"
      style="margin-top: 24px; margin-bottom: 16px;"
    >
      <span *ngIf="!retrying">{{ "ERROR_503.RETRY" | translate }}</span>
      <span *ngIf="retrying">{{ "ERROR_503.RETRYING" | translate }}</span>
    </button>

    <a class="report-link" (click)="onVisitGt2()">{{
      "ERROR_503.GT2_SITE" | translate
    }}</a>
  </div>
</div>
